import React from 'react'
import { RouteObject } from 'react-router-dom'

import Dashboard from '@sputnik/pages/Dashboard'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'

export const createLegacyDashboardRoutes = (): RouteObject[] => {
  return [
    {
      path: '/',
      element: <Dashboard />,
    },
    {
      path: PATHNAME_CONSTS.DASHBOARD_PATH,
      element: <Dashboard />,
    },
  ]
}
